import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import gif from "@assets/gifs/network_error.svg";
import { BeoButton } from "@components/common/action";
/**
 * NetworkError component displays a visual indication of a network error.
 * It renders an SVG image to communicate the error state to the user.
 * Also provides a button to navigate back to the home page.
 *
 * @component
 * @author niyas.shajahan
 * @since 2025-06-19
 */
var NetworkError = function () {
    return (_jsxs("div", { className: "flex flex-col items-center justify-center min-h-screen bg-white space-y-6", children: [_jsx("img", { className: "w-full max-w-screen-md h-auto animate-zoom-in duration-500", src: gif, alt: "Network Error" }), _jsx(BeoButton, { id: "nw-err-btn", label: "Go to login", onClick: function () { return (window.location.href = "/login"); }, className: "px-6 py-2 rounded-lg bg-amber-500 border-none text-white font-semibold shadow-md hover:bg-[var(--primary-color-dark)] hover:text-amber-500 transition-all duration-300" })] }));
};
export default NetworkError;
